<template>
  <div>
  <section class="hero top is-fullheight">
    <div class="hero-head level">
      <div class="level-item">
        <img class="logo" src="@/assets/gtc.png">
      </div>
    </div>
    <div class="hero-body">
      <div class="container hero-text">
          <!-- <div class="columns">
            <div class="column is-one-half">
              <div class="columns has-text-centered">
                <h1 class="column is-one-quarter has-text-centered">Design</h1>
              </div>
              <div class="columns">
                <h1 class="column is-one-quarter is-offset-one-quarter">Build</h1>
              </div>
              <div class="columns">
                <h1 class="column is-one-quarter is-offset-half">Test</h1>
              </div>
              <div class="columns">
                <h1 class="column is-one-quarter is-offset-three-quarters">Evaluate</h1>
              </div>
            </div>
          </div> -->
          <h1>Innovate faster</h1>
        </div>
      </div>
    <!-- </div> -->
    <div class="hero-foot"></div>
  </section>
  <section class="hero is-fullheight overview">
    <div class="hero-head">
    </div>
    <div class="hero-body">
      <div class="container">
        <div class="columns">
          <div class="column is-three-fifths-desktop is-two-thirds-tablet">
            <h2>{{overview.title}}</h2>
            <div class="level"></div>
            <p>{{overview.description}}
            </p>
          </div>
          <div class="column is-offset-one-fifth-desktop">
            <h4>Our Specialties</h4>
            <ul>
              <li v-for="speciality in overview.specialties">{{speciality}}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="hero-foot"></div>
  </section>
   <section class="hero is-fullheight">
    <div class="hero-head">
    </div>
    <div class="hero-body process">
     <div class="container">
      <div class="columns">
        <div class="column is-three-fifths">
          <h2>How we prototype</h2>
          <h4>We'll help you step back from the whiteboard and create something real</h4>
          <div class="level"></div>
          <div class="level"></div>
          <h4>Explore</h4>
          <p>research / sketch / conceptualize</p>
          <div class="level"></div>
          <h4>Make</h4>
          <p>design / code / release</p>
          <div class="level"></div>
          <h4>Learn</h4>
          <p>test / measure / iterate</p>
        </div>
        <div class="column is-two-fifths">
          <img class="image" src="@/assets/gtcprocess.png">
        </div>
      </div>
    </div>
  </div>

  <!-- </div>
    </div> -->
    
    <div class="hero-foot"></div>
    
  </section>
  <div v-for="project in projects" v-bind:item:="project" v-bind:key="projects.indexOf(project)">
    <work-project :project='project'></work-project>
  </div>
  <section class="hero is-fullheight">
    <div class="hero-head">
    </div>
    <div class="hero-body">
     <!--  <div class="container">
        <div class="columns is-variable">
          <div class="column">
            <h2>Contact us</h2>
            <div class="level"></div>
            <p>Say hello!
            </p>
            <div class="level"></div>
            <div class="columns">
              <div class="column">
                <b-field>
                  <b-input placeholder="name"></b-input>
                </b-field>
                <b-field>
                  <b-input placeholder="email"></b-input>
                </b-field>
              </div>
              <div class="column">
                <b-field>
                  <textarea class="textarea" type="text" placeholder="message" rows="3" style="height: 93px"></textarea>
                </b-field>
              </div>
            </div>
            <div class="level">
              <div class="level-item level-right">
                <button class="button is-primary is-outlined">Send</button>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <contact-form context="home"></contact-form>
    </div>

    <div class="hero-foot"></div>
    
  </section>
</div>
</template>

<script>
import WorkProject from '@/components/WorkProject'
import ContactForm from '@/components/ContactForm'
export default {
  name: 'Home',
  components: {WorkProject,ContactForm},
  data () {
    return {
      overview: {
        title: `we are nyc-based designers and engineers that specialize in rapid prototyping`,
        description: `Good Tech works with big and small brands to create exciting digital experiences. We prioritize speed, building, and testing.`,
        specialties: [
          'Digital Design',
          'Augmented/Virtual Reality',
          'Research',
          'Brand Strategy',
          'Brand Identity',
          'Marketing Strategy',
          'Engineering',
          'Data Analytics'
        ]
      },
      projects: [
        {
          logo: 'fc.png',
          name: 'flightclub',
          bg: 'fc-bg.jpg',
          title: 'Innovation with the original sneaker marketplace',
          description: 'Good Tech designed and built a suite of internal tools to help Flight Club transform its technology to be as fresh as its sneakers',
          specialties: [
            'UX + UI Design',
            'System Design',
            'User Research',
            'Web + Mobile Engineering',
            'Product Development',
            'Data Analytics'
          ]
        }
        ,
        {
          logo: 'nars.png',
          name: 'nars',
          bg: 'nars-bg.jpg',
          title: 'Combining cutting edge tech with a worldwide product launch', 
          description: 'Good Tech designed and developed a fully browser-based Instagram selfie filter for NARS\'s Climax Mascara launch',
          link: 'https://howdoyouclimax.com',
          specialties: [
            'UX + UI Design',
            'Rapid Prototyping',
            'Engineering',
            'Product Development'
          ]
        }
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  @import url("https://use.typekit.net/mzm5taf.css");
  html {
    border: 5px solid #FFF200;
  }
  .hero-head {
    padding-top: 20px;
  }
  .top .hero-body {
    padding-bottom: 250px;
  }
  .hero-text {
    .column {
      // margin-bottom: -54px;
    }
  }
  .hero-body {
    h1, h2, h4, h5 {
      font-family: "futura-pt-bold";
      text-transform: uppercase;
      font-size: 48px;
    }
    h2 {
      @media screen and (max-width: 500px) {
        font-size: 36px;
      }
    }
    h1 {
      font-size: 96px;
      text-align: center;
      // transform: rotate(-10deg);
      @media screen and (max-width: 500px) {
        font-size: 50px;
      }
    }
    h4 {
      font-size: 16px;
      margin-bottom: 15px;
      margin-top: 11px;
    }
    h5 {
      font-size: 12px;
    }
    p, li, input, textarea, a {
      font-family: "courier-std";
      font-size: 22px;
      @media screen and (max-width: 500px) {
        font-size: 18px;
      }
    }
    a {
      color: white;
      text-decoration: underline;
      text-transform: uppercase;
    }
    li {
      font-size: 18px;
      line-height: 2;
    }
    input, textarea {
      background: none;
      border: 1px solid black;
      border-radius: 0;

    }
    input {
       height: 50px !important;
    }
  }
  .process {
    h4 {
      margin: 0;
    }
  }
  .button {
    font-family: "futura-pt-bold";
    text-transform: uppercase;
    border-radius: 0;
    border: 2px solid black;
  }
  .logo {
    height: 150px;
  }
  .overview {
    color: white;
    background:linear-gradient(rgba(0,0,0,0.65),rgba(0,0,0,0.65)), url('../assets/hero/8-s.jpg');
    background-size: cover;
    background-position: 50%;
    background-repeat: no-repeat;
  }
  .top {
    color: white;
    background:linear-gradient(rgba(0,0,0,0.65),rgba(0,0,0,0.65)), url('../assets/hero/9-s.jpg');
    background-size: cover;
    background-position: 50%;
    background-repeat: no-repeat; 
  }
  button {
    width: 250px;
    height: 50px !important;
  }
  button.is-primary {
    color: black !important;
    border: 2px solid black !important;
    &:hover, &:active, &:focus {
      color: white !important;
      background-color: black !important;
    }
  }
  .input:focus, .taginput .taginput-container.is-focusable:focus, .input.is-focused, .taginput .is-focused.taginput-container.is-focusable, .input:active, .taginput .taginput-container.is-focusable:active, .input.is-active, .taginput .is-active.taginput-container.is-focusable, .textarea:focus, .textarea.is-focused, .textarea:active, .textarea.is-active {
      border-color: black !important;
      box-shadow: none !important;
  }
  .input:hover, .taginput .taginput-container.is-focusable:hover, .input.is-hovered, .taginput .is-hovered.taginput-container.is-focusable, .textarea:hover, .textarea.is-hovered {
    border-color: black !important;
  }
  .modal-content {
    width: 100% !important;
    padding: 0;
    margin: 0 !important;
    max-height: inherit !important;
    max-width: inherit !important;
    h2, h5, p {
      color: black !important  
    }
    
  }
  .is-large.delete, .is-large.modal-close {
    right: initial;
    left: 20px;
    color: black;
  }
  .delete::before, .modal-close::before, .delete::after, .modal-close::after {
    background-color: black !important;
  }

  .animate {
    transition-delay: .1s;
    transition-duration: .25s;
    transition-timing-function: ease-in;
  }
   
  .slide-up {
    transform: translateY(0);
  }
   
  .slide-up.animate-active {
    transform: translateY(-100px);
  }


</style>



// WEBPACK FOOTER //
// src/components/Home.vue